import { Link } from 'react-router-dom'
import { isDebt } from "../../constants/ACCOUNT_TYPE";
import { IconBudget } from "../../assets/icons";
import { formatCurrency } from "../../utilities/general-utils";
import styles from "./AccountPreview.module.css";

const AccountPreview = ({ account, disableLink = false, addBorder = false }) => {
    return (
        <div className={`${styles.accountPreviewWrap} ${account.includeBalance ? `${styles.balanceIncluded} bg-light-green` : ''} ${addBorder ? styles.addBorder : ''}`}>
            {disableLink ? (
                <div className={`${styles.accountPreview}`}>
                    <AccountContent account={account} />
                </div>
            ) : (
                <Link to={`/account/${account.id}`} className={`${styles.accountPreview}`}>
                    <AccountContent account={account} />
                </Link>
            )}
        </div>
    )
}

const AccountContent = ({ account }) => {
    const balanceProperty = isDebt(account.type)
        ? account?.balance ?? account?.debtAccountInfo?.balance
        : account.availableBalance;

    return (
        <>
            <div className={styles.accountPreviewCenter}>
                <h3 className={styles.accountPreviewTitle}>
                    {account.name}

                    <div className={styles.accountPreviewIcons}>
                        {account.includeBalance ? <div className={styles.accountPreviewIcon} title="Included in budget"><IconBudget /></div> : ""}
                    </div>
                </h3>

                <h4 className={styles.accountPreviewInstitution}>
                    {account.institution ?? null}
                </h4>
            </div>

            <div className={styles.accountPreviewRight}>
                <div className={styles.accountPreviewBalance}>
                    {isDebt(account.type) && balanceProperty > 0 ? "-" : ""}{formatCurrency(balanceProperty)}
                </div>
            </div>
        </>
    )
}


export default AccountPreview